import { thunk } from "redux-thunk";
import { createStore, applyMiddleware } from "redux";
import { composeWithDevTools } from "@redux-devtools/extension";
import { Provider } from "react-redux";

import BaseComponent from "@js/components/base_component.jsx";
import SuppressedAddressSearchInner from "@js/components/suppressed_address_search/inner.jsx";

import rootReducer from "@js/reducers/suppressed_address_search/reducers.js";

class SuppressedAddressSearch extends BaseComponent {

  constructor(props) {
    super(props);

    this.store = createStore(
      rootReducer,
      {
        suppressionListID: props.suppression_list_id,
      },
      composeWithDevTools(applyMiddleware(thunk)),
    );
  }

  render() {
    return (
      <Provider store={ this.store }>
        <SuppressedAddressSearchInner />
      </Provider>
    );
  }

}

export default SuppressedAddressSearch;
